import * as React from "react";
import { GlobalContext } from "../../context/GlobalContextProvider";
import { Modal, Select } from "antd";
import { useEffectOnce } from "../../helpers/useEffectOnce";
import { Tenant, TenantsApi } from "../../client";
import { useEffect } from "react";

interface IProps {}

interface IOption {
    value: string;
    label: string;
    onSelect: () => Promise<void>;
}

export const HotkeySwitchModal: React.FC<IProps> = (props) => {
    const [searchValue, setSearchValue] = React.useState("");
    const [options, setOptions] = React.useState<IOption[]>([]);

    const selectRef = React.useRef<any>();
    const globalContext = React.useContext(GlobalContext);

    const isSuperUser = globalContext.user?.isSuperuser || false;

    useEffectOnce(() => {
        if (!isSuperUser) {
            return;
        }

        new TenantsApi().listTenants().then((res) => {
            const tenants: Tenant[] = [
                ...res.data.results,
                {
                    id: 0,
                    name: "Clear tenant",
                },
            ];
            const newOptions: IOption[] = tenants.map((tenant) => ({
                label: tenant.name,
                value: `tenant-${tenant.id}`,
                onSelect: async () => {
                    await new TenantsApi().flipTenant({
                        id: tenant.id.toString(),
                    });

                    // Reload the window.
                    window.location.reload();
                },
            }));
            setOptions(newOptions);
        });
    });

    useEffect(() => {
        if (globalContext.tenantSwitchModal.open) {
            setTimeout(() => {
                if (selectRef.current) {
                    selectRef.current.focus();
                }
            }, 10);
        }
    }, [globalContext.tenantSwitchModal.open]);

    if (!isSuperUser) {
        return null;
    }

    if (!globalContext.tenantSwitchModal.open) {
        return null;
    }

    return (
        <Modal
            open={true}
            onCancel={() => globalContext.tenantSwitchModal.onChange(false)}
            footer={null}
            closeIcon={<></>}
        >
            <Select
                ref={selectRef}
                showSearch={true}
                searchValue={searchValue}
                onSearch={setSearchValue}
                style={{ width: "100%" }}
                size="large"
                autoFocus={true}
                placeholder={"search"}
                options={options}
                onSelect={(optionValue: string) => {
                    const option = options.find((o) => o.value === optionValue);
                    if (option) {
                        option
                            .onSelect()
                            .then(() =>
                                globalContext.tenantSwitchModal.onChange(false)
                            );
                    }
                }}
                filterOption={(inputValue, option) =>
                    option
                        ? option.label
                              .toLowerCase()
                              .includes(inputValue.toLowerCase())
                        : true
                }
            />
        </Modal>
    );
};
